import { Component, Input } from '@angular/core';
import { Events } from 'ionic-angular';

/**
 * Generated class for the SegmentsComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'segments',
  templateUrl: 'segments.html'
})
export class SegmentsComponent {
  @Input() page: string = 'HomePage';

  constructor(public eventsCtrl: Events) {
  }

  openPage(event) {
    let params: any = { filtername: 'all' };
    switch (event.value) {
      case 'ScreensPage':
        params = { filtername: 'all' };
        break;
      case 'WatchListsPage':
        params = { filtername: 'personal' };
        break;
      case 'CoveragePage':
        params = { section: 'sectors' };
        break;
    }

    this.eventsCtrl.publish('openPage', event.value, params);
  }
}



// WEBPACK FOOTER //
// ./src/components/segments/segments.ts